import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = allArticles.filter((a) => a.isFeatured).slice(0, 4);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold mb-3">
            精选推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            热门文章
          </h2>
          <p className="text-foreground-500 max-w-lg mx-auto text-sm">
            精心挑选的最受欢迎内容，帮助你快速建立寸止挑战的系统认知
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featured.map((article, i) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-48 h-48 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-5 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                      {article.categoryName}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readTime} 分钟阅读</span>
                  </div>
                  <h3 className="font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors text-base mb-2 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 line-clamp-2">{article.excerpt}</p>
                </div>
                <div className="flex items-center gap-2 mt-3 text-xs text-foreground-400">
                  <i className="ri-calendar-line" />
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/rumen-jiaocheng"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}